/**
 * Right Arrow Button Component
 * Custom styled arrow button for horizontal scrolling
 */

import React from 'react';

export interface RightArrowButtonProps {
  onClick?: () => void;
  ariaLabel?: string;
}

export const RightArrowButton: React.FC<RightArrowButtonProps> = ({
  onClick,
  ariaLabel = 'Scroll right',
}) => {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      style={{
        display: 'flex',
        padding: '8px',
        alignItems: 'center',
        gap: '8px',
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        borderRadius: 'var(--Dimensions-Border-border-Full, 9999px)',
        border: '1px solid var(--Colors-Stroke-Base, #D6D3D1)',
        background: 'rgba(28, 25, 23, 0.50)',
        width: '36px',
        height: '36px',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s',
        justifyContent: 'center',
        zIndex: 10,
      }}
      onMouseEnter={e => {
        if (onClick) {
          e.currentTarget.style.opacity = '0.8';
        }
      }}
      onMouseLeave={e => {
        if (onClick) {
          e.currentTarget.style.opacity = '1';
        }
      }}
    >
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M8 5L13 10L8 15M13 10H3'
          stroke='#FFFFFF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </button>
  );
};
